/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An MCP server an auth client is associated with.
 */
export type AuthClientServer = {
  /**
   * The MCP server id.
   */
  id: string;
  /**
   * The MCP server's name.
   */
  name?: string | undefined;
  /**
   * The MCP server's project.
   */
  projectId: string;
  /**
   * Whether the MCP server is public.
   */
  public: boolean;
  /**
   * The MCP server's slug.
   */
  slug?: string | undefined;
};

/** @internal */
export const AuthClientServer$inboundSchema: z.ZodMiniType<
  AuthClientServer,
  unknown
> = z.pipe(
  z.object({
    id: z.string(),
    name: z.optional(z.string()),
    project_id: z.string(),
    public: z.boolean(),
    slug: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "project_id": "projectId",
    });
  }),
);

export function authClientServerFromJSON(
  jsonString: string,
): SafeParseResult<AuthClientServer, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AuthClientServer$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AuthClientServer' from JSON`,
  );
}
